exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-secondary[data-v-b12176a6]{color:#6a6969}.btn-outline-secondary[data-v-b12176a6]:hover{color:#f7f7f7;background-color:#6a6969;border-color:#6a6969}.hidden[data-v-b12176a6]{opacity:0}.speech-bubble-tooltip[data-v-b12176a6]{background:#f7f7f7;border-radius:.4em;padding:15px 10px;font-size:24px;color:#6a6969;float:left;bottom:23px;right:-55px;min-width:300px;z-index:100000}.speech-bubble-tooltip[data-v-b12176a6]:after{content:\"\";position:absolute;bottom:0;right:45px;width:0;height:0;border:20px solid transparent;border-top-color:#f7f7f7;border-bottom:0;margin-left:-20px;margin-bottom:-20px;z-index:100000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b12176a6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/general/help-bottom-right.vue
// module id = 1959
// module chunks = 0